/*!
  Atom, by Koding Themes
  slideshow.js
  https://kodingthemes.com
*/

var slideshowIntervals = [];

function newSlideshow() {
  // clear previous autoplay intervals to prevent stacking
  slideshowIntervals.forEach(function (id) {
    clearInterval(id);
  });
  slideshowIntervals = [];

  // slideshow onload
  var sliders = document.querySelectorAll(".new-animation-slider");
  sliders.forEach(function (slider) {
    var slides = slider.querySelectorAll(".slide-item");
    if (slides.length === 0) return;
    var slideIndex = slider.querySelector(".slide-index");
    var slideIndexTotalText = slider.querySelector(".slide-index-total");
    var slideIndexInnerText = slider.querySelector(".slide-index-inner");

    var slideUnderline = slides[0].querySelector(".slide-animated-underline");
    if (slideUnderline != null) {
      slideUnderline.classList.add("active");
    }

    if (slideIndex != null) {
      slideIndexTotalText.innerHTML = ("0" + slides.length).slice(-2);
      slideIndexInnerText.innerHTML = "01";
    }
  });

  // Load slider controls
  var controls = document.querySelectorAll(".slide-navigation a");
  controls.forEach(function (btn) {
    btn.onclick = function (e) {
      e.preventDefault();
      var step = btn.dataset.slidestep;
      var slider = btn.closest(".new-animation-slider");
      var slides = slider.querySelectorAll(".slide-item");
      var slideCount = slides.length - 1;

      var slideIndexTotalText = slider.querySelector(".slide-index-total");
      var slideIndexInnerText = slider.querySelector(".slide-index-inner");
      if (slideIndexTotalText) {
        slideIndexTotalText.innerHTML = ("0" + slides.length).slice(-2);
      }

      var currentIndex = -1;
      slides.forEach(function (slide, index) {
        if (slide.classList.contains("current-slide")) {
          currentIndex = index;
        }
      });
      if (currentIndex === -1) return;

      var slideNext = 0;
      slider.classList.remove("slide-up");
      slider.classList.remove("slide-down");
      if (step == "next") {
        slider.classList.add("slide-up");
        slideNext = currentIndex + 1;
        if (slideNext > slideCount) {
          slideNext = 0;
        }
      } else {
        slider.classList.add("slide-down");
        slideNext = currentIndex - 1;
        if (slideNext < 0) {
          slideNext = slideCount;
        }
      }
      slides[currentIndex].classList.add("change-slide");
      slides[slideNext].classList.add("upcoming-slide");
      setTimeout(function () {
        slides[currentIndex].classList.remove("current-slide");
        slides[currentIndex].classList.remove("change-slide");
        slides[slideNext].classList.add("current-slide");
        setTimeout(function () {
          slides[slideNext].classList.remove("upcoming-slide");
          setTimeout(function () {
            var prevUnderline = slides[currentIndex].querySelector(".slide-animated-underline");
            var nextUnderline = slides[slideNext].querySelector(".slide-animated-underline");
            if (prevUnderline) prevUnderline.classList.remove("active");
            if (nextUnderline) nextUnderline.classList.add("active");
          }, 800);
        }, 100);
      }, 400);

      if (slideIndexInnerText) {
        slideIndexInnerText.innerHTML = ("0" + (slideNext + 1)).slice(-2);
      }
    };
  });

  // autoplay slider
  var slideNexts = document.querySelectorAll("a.slide-navigation-item-next");
  slideNexts.forEach(function (btn) {
    var sliderSection = btn.closest(".new-animation-slider");
    if (sliderSection != null) {
      var autoplay = sliderSection.dataset.autoplay;
      var speed = sliderSection.dataset.autoplaySpeed;
      speed = speed * 1000;
      if (autoplay == "true") {
        var intervalId = setInterval(function () {
          btn.click();
        }, speed);
        slideshowIntervals.push(intervalId);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  newSlideshow();
});
document.addEventListener("shopify:section:load", function () {
  newSlideshow();
});
document.addEventListener("shopify:section:reorder", function () {
  newSlideshow();
});
